var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8047 10.8334C11.2649 10.8334 11.638 10.4603 11.638 10C11.638 9.5398 11.2649 9.16671 10.8047 9.16671C10.3445 9.16671 9.97136 9.5398 9.97136 10C9.97136 10.4603 10.3445 10.8334 10.8047 10.8334Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8047 5.00004C11.2649 5.00004 11.638 4.62694 11.638 4.16671C11.638 3.70647 11.2649 3.33337 10.8047 3.33337C10.3445 3.33337 9.97136 3.70647 9.97136 4.16671C9.97136 4.62694 10.3445 5.00004 10.8047 5.00004Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8047 16.6667C11.2649 16.6667 11.638 16.2936 11.638 15.8334C11.638 15.3731 11.2649 15 10.8047 15C10.3445 15 9.97136 15.3731 9.97136 15.8334C9.97136 16.2936 10.3445 16.6667 10.8047 16.6667Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVertical);
export default __webpack_public_path__ + "static/media/dots-vertical.79613842c7fe0b6a8c8e8ddedfbc72b3.svg";
export { ForwardRef as ReactComponent };